import { createSelector } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';

interface IState {
  user: any;
  token: string;
  success: boolean;
}
export const ProfileHook = () => {
  const selectProfile = (state: RootState) => state.Login;
  const profileProperties = createSelector([selectProfile], (e) => ({
    user: e.user,
    token: e.token,
    success: e.success,
  }));

  const { user, token, success } = useSelector(profileProperties);

  const [state, setState] = useState<IState>({
    user,
    token,
    success,
  });

  useEffect(() => {
    setState((v) => ({ ...v, user }));
  }, [user]);

  useEffect(() => {
    setState((v) => ({ ...v, token }));
  }, [token]);

  useEffect(() => {
    setState((v) => ({ ...v, success }));
  }, [success]);

  return state;
};
